import {expandedCardStyle} from '../../styles';
import {Box, Skeleton} from '@mui/material';
import {expandedMonthlyRevenueSkeletonStyles} from './styles';

const ExpandedMonthlyRevenueSkeleton = () => {
  return (
    <Box sx={expandedCardStyle}>
      <Skeleton
        variant="rectangular"
        sx={expandedMonthlyRevenueSkeletonStyles}
        animation="wave"
      />
    </Box>
  );
};

export default ExpandedMonthlyRevenueSkeleton;
